import { c as _c } from "react/compiler-runtime";
import BoringAvatar from "boring-avatars";
import type * as React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
const DEFAULT_MARBLE_COLORS = ["#005F73", "#00967B", "#6BC4B6", "#F5CB0E", "#C7D4D6"];
type UserAvatarProps = Omit<React.ComponentProps<typeof Avatar>, "children"> & {
  image?: string | null;
  name?: string | null;
  seed?: string | null;
  colors?: string[];
  variant?: "beam" | "marble" | "bauhaus" | "pixel" | "ring" | "sunset";
  fallbackClassName?: string;
  label?: string;
  decorative?: boolean;
};
function UserAvatar(t0) {
  const $ = _c(36);
  let className;
  let fallbackClassName;
  let image;
  let label;
  let name;
  let props;
  let seed;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      decorative: t1,
      fallbackClassName,
      image,
      label,
      name,
      seed,
      colors: t2,
      variant: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = fallbackClassName;
    $[3] = image;
    $[4] = label;
    $[5] = name;
    $[6] = props;
    $[7] = seed;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    className = $[1];
    fallbackClassName = $[2];
    image = $[3];
    label = $[4];
    name = $[5];
    props = $[6];
    seed = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  const decorative = t1 === undefined ? false : t1;
  const colors = t2 === undefined ? DEFAULT_MARBLE_COLORS : t2;
  const variant = t3 === undefined ? "beam" : t3;
  let t4;
  if ($[11] !== seed) {
    t4 = seed?.trim() || "clutch-user";
    $[11] = seed;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const resolvedSeed = t4;
  let t5;
  if ($[13] !== label || $[14] !== name) {
    t5 = label?.trim() || name?.trim() || "User avatar";
    $[13] = label;
    $[14] = name;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const accessibleLabel = t5;
  let t6;
  if ($[16] !== accessibleLabel || $[17] !== decorative) {
    t6 = decorative ? {
      "aria-hidden": true as const
    } : {
      "aria-label": accessibleLabel,
      role: "img" as const
    };
    $[16] = accessibleLabel;
    $[17] = decorative;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const accessibilityProps = t6;
  let t7;
  if ($[19] !== image) {
    t7 = image ? <AvatarImage src={image} alt="" aria-hidden="true" /> : null;
    $[19] = image;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== fallbackClassName) {
    t8 = cn("[&>svg]:!size-full overflow-hidden bg-transparent p-0 text-transparent", fallbackClassName);
    $[21] = fallbackClassName;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== colors || $[24] !== resolvedSeed || $[25] !== variant) {
    t9 = <BoringAvatar size="100%" name={resolvedSeed} variant={variant} colors={colors} />;
    $[23] = colors;
    $[24] = resolvedSeed;
    $[25] = variant;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <AvatarFallback aria-hidden="true" className={t8}>{t9}</AvatarFallback>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== accessibilityProps || $[31] !== className || $[32] !== props || $[33] !== t10 || $[34] !== t7) {
    t11 = <Avatar className={className} {...accessibilityProps} {...props}>{t7}{t10}</Avatar>;
    $[30] = accessibilityProps;
    $[31] = className;
    $[32] = props;
    $[33] = t10;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
}
export { DEFAULT_MARBLE_COLORS, UserAvatar };